import moment from "@/utils/moment";
import "moment/locale/pt-br";
moment.locale("pt-BR");

export default {
  filters: {
    fromMinutesToHours(minutes) {
      return minutes / 60;
    },

    stringifyHours(hours = 0, abbreviated = true) {
      if (abbreviated) {
        return `${hours}h`;
      }

      return `${hours} hora${hours > 1 ? "s" : ""}`;
    },

    formatDate(date, type = "DD/MM/Y HH:mm:ss") {
      return moment(date).format(type);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/generic/dateAndTimeMixin.js